import React, { useEffect, useState } from "react"
import { useSelector, useDispatch } from "react-redux"

import { ADD, EDIT, IDLE, PENDING } from "const"
import { StateType, hasAccess } from "client/utils"
import {
    PRM_GROUP,
    StoreType,
    GroupProps,
    LoadGroupById,
    setGroupEdit,
    setGroupReloadEdit,
    initGroup,
} from "client/store"
import {
    Container,
    PageHeader,
    PageTitle,
    PageContent,
    Loader,
} from "client/components"

import NotFound from "client/parts/notFound"
import AccessDenied from "client/parts/accessDenied"
import Form from "./form"

const Edit = ({
    groupId = null,
}: GroupProps) => {
    const group = useSelector((state: StoreType) => state.group.groupEdit)
    const reloadEdit = useSelector((state: StoreType) => state.group.reloadEdit)

    const userData = useSelector((state: StoreType) => state.system.userData)
    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const [loadState, setLoadState] = useState<StateType>(IDLE)

    const reload = () => {
        dispatch(setGroupReloadEdit(false))
        setTimeout(() => {
            dispatch(setGroupReloadEdit(true))
        }, 0)
    }

    useEffect(() => {
        if (groupId === 0) {
            dispatch(setGroupEdit(initGroup))
            reload()
        } else {
            setLoadState(PENDING)
            LoadGroupById(groupId, userData.accountId).then((res) => {
                dispatch(setGroupEdit(res))
                setLoadState(IDLE)
                reload()
            })
        }
    }, [])

    const addAccess = hasAccess(PRM_GROUP, ADD)
    const editAccess = hasAccess(PRM_GROUP, EDIT)
    const allowedToEdit = group.accountId === userData.accountId
        ? editAccess || group.creator === userData.userId
        : false

    if (groupId === 0 && !addAccess) return <AccessDenied />
    if (groupId !== 0 && !allowedToEdit) return <AccessDenied />
    if (!group) return <NotFound />

    return (
        <Container>
            <PageHeader>
                <PageTitle>
                    {group.id ? `${lang.editGroup} # ${group.id}` : lang.addGroup}
                </PageTitle>
            </PageHeader>
            <PageContent>
                {loadState === PENDING && <Loader />}
                {
                    !reloadEdit
                    && <Form group={group} />
                }
                {
                    reloadEdit
                    && <Form group={group} />
                }
            </PageContent>
        </Container>
    )
}
export default Edit
